@if (profile$ | async; as profile) {
  @if (profile.trixels.profile) {
    <rma-trixel [trixelImgUrl]="profile.trixels.profile" [trixelSourceCategory]="profileSourceCategory" />
  }
  @if (showPremiumToggle$ | async) {
    <rma-profile-premium-toggle [checked]="premiumOverride$ | async" [hasTrial]="hasTrial$ | async" (switch)="onPremiumToggle($event)" />
  }
  <div class="mx-auto block max-w-[70rem] py-6 pb-36" [class]="'profile-' + profile.featureLevel">
    <header class="mx-6 xl:mx-0">
      <div class="mb-1 flex flex-row items-center justify-end">
        <div class="flex flex-row items-center justify-between">
          <rma-share-button [data]="share$ | async" buttonType="responsive" />
        </div>
      </div>
      <rma-profile-header [profile]="profile" [badges]="badges$ | async" />
    </header>
    <div class="flex space-x-12">
      <div class="flex w-full flex-col space-y-6 lg:w-2/3">
        <div *rmaIsBasicProfile="profile.featureLevel" class="mx-6 block lg:hidden xl:mx-0">
          <ng-container *ngTemplateOutlet="recognition; context: { $implicit: true }" />
        </div>
        <ng-container *rmaIsPremiumProfile="profile.featureLevel">
          @if (awards$ | async; as awards) {
            @if (awards.length) {
              <rma-profile-awards class="divider-b mx-6 xl:mx-0" [awards]="awards" [name]="profile.shortName ?? profile.fullName" />
            }
          }
        </ng-container>
        @if (showClaim$ | async) {
          <rma-claim-profile-banner class="mx-6 lg:hidden" [profile]="profile" />
        }
        <rma-profile-about
          class="divider-b mx-6 md:mr-3 xl:mx-0"
          [stats]="[]"
          [profile]="profile"
          [galleryAssets]="galleryAssets$ | async"
        />
        @if (reviews$ | async; as reviews) {
          @if (reviewAttributes$ | async; as attributes) {
            <rma-profile-reviews-overview
              class="divider-b mx-6 md:mr-3 xl:mx-0"
              [profile]="profile"
              [reviews]="reviews"
              [reviewAttributes]="attributes"
            />
          }
        }
        <ng-container *rmaIsBasicProfile="profile.featureLevel">
          @defer (on viewport) {
            <rma-profile-external-reviews
              [profileType]="profile.profileType"
              [profileCode]="profile.profileCode"
              [name]="profile.shortName || profile.fullName"
            />
          } @placeholder {
            <rma-skeleton-grid heightClass="h-60" gapClass="gap-3.5" />
          } @error {}
        </ng-container>
        <div *rmaIsPremiumProfile="profile.featureLevel" [class.hidden]="downgrade$ | async">
          @defer (on viewport) {
            @if (showMapCta$ | async) {
              <rma-profile-map-inline
                class="divider-b block w-full px-6 xl:px-0"
                [verticalType]="profile.profileVertical"
                [profileType]="profile.profileType"
                [profileCode]="profile.profileCode"
                [name]="profile.shortName ?? profile.fullName"
                [canHaveProperties]="false"
                mapType="Review"
              />
            }
          } @placeholder {
            <img alt="map" class="h-96 w-full object-cover" [src]="'maps/map-placeholder.svg' | staticImageUrl" />
          } @error {}
        </div>
        @if (profile.contact.enableContactForm) {
          <rma-contact-form-cta
            id="contactForm"
            class="mx-6 xl:mx-0"
            [verticalType]="profile.profileVertical"
            [profileCode]="profile.profileCode"
            [profileType]="profile.profileType"
            [branding]="profile.featureLevel !== 'Default' ? profile.branding : undefined"
            [name]="profile.fullName"
            [avatar]="profile.avatarUrl"
            [shortName]="profile.shortName"
            [contactUrl]="contactUrl$ | async"
            [enquiryTypes]="enquiryTypes"
            [trixelUrl]="profile.trixels.contact"
            [trixelSourceCategory]="contactTrixelSourceCategory"
            [isPaidProfile]="profile.featureLevel !== 'Default'"
          />
        }
      </div>
      <div class="sticky top-20 hidden w-1/3 grow-0 space-y-6 self-start pr-6 lg:flex lg:flex-col xl:pr-0">
        <ng-container *rmaIsBasicProfile="profile.featureLevel">
          <ng-container *ngTemplateOutlet="contactTemplate" />
          <ng-container *ngTemplateOutlet="recognition" />
        </ng-container>
        @if (showClaim$ | async) {
          <rma-claim-profile-banner [profile]="profile" />
        }
      </div>
    </div>
    <div class="fixed bottom-0 z-50 w-full bg-white shadow-inner lg:hidden">
      <ng-container *ngTemplateOutlet="contactTemplate" />
    </div>
    <ng-template #contactTemplate>
      <rma-profile-contact
        [profileCode]="profile.profileCode"
        [profileType]="profile.profileType"
        [branding]="profile.featureLevel !== 'Default' ? profile.branding : undefined"
        [name]="profile.fullName"
        [avatar]="profile.avatarUrl"
        [ratingValue]="profile.ratingValue"
        [reviewCount]="profile.reviewCount"
        [contact]="profile.contact"
        [contactUrl]="contactUrl$ | async"
        [contactAnalytics]="contactAnalytics$ | async"
        [showMarketReport]="profile.hasMarketReports"
        [trixelUrl]="profile.trixels.contact"
        [trixelSourceCategory]="contactTrixelSourceCategory"
      />
    </ng-template>
    @if (!profile.isClaimed) {
      <rma-unclaimed-profile-disclaimer />
    }
    <ng-template #recognition let-divider>
      @if (badges$ | async; as badges) {
        <rma-profile-recognition
          [class.divider-b]="divider"
          [showAwards]="profile.featureLevel === 'Premium'"
          [badges]="badges"
          [name]="profile.shortName ?? profile.fullName"
        />
      }
    </ng-template>
    <span class=""></span>
  </div>
}
